
import React from "react";
import { CalendarView } from "@/components/calendar/CalendarView";

export default function CalendarPage() {
  return (
    <div className="space-y-4 p-4">
      <h1 className="text-2xl font-bold">Calendar</h1>
      <p className="text-muted-foreground">
        Schedule and manage your client activities, tasks, and meetings
      </p>
      
      <CalendarView />
    </div>
  );
}
